import { produto, SearchProduto, suggestionproduto, filterprice, getproduct, produtcId } from './query'
import router from '../../router'
export default {
  GetStoreProducts ({ commit }, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: produto,
        variables: {
          payload: payload.params
        }
      })
      .then(res => {
        commit('SET_PRODUTOS_STORE', { produtos: res.data.data.Produto, init: payload.init })
        resolve()
      })
    })
  },
  GetProductId ({ commit }, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: produtcId,
        variables: {
          payload: payload
        }
      })
      .then(res => {
        console.log(res.data.data.GetProductId)
        commit('ITEM_SELECTED01', res.data.data.GetProductId)
        resolve()
      })
    })
  },
  ToggleCheckout01 ({ commit }, payload) {
    commit('TOGGLE_CHEKCOUT01', payload)
  },
  ToggleSearch01 ({ commit }, payload) {
    commit('TOGGLE_SEARCH01', payload)
  },
  ToggleSideNave ({ commit }, payload) {
    commit('TOGGLE_SIDENAVE', payload)
  },
  PushCheckout01 ({ commit }, payload) {
    commit('PUSH_CHECKOUT01', payload)
  },
  ClearCheckout01: ({ commit }) => new Promise((resolve) => {
    commit('CLEAR_CHECKOUT01')
    resolve()
  }),
  QtdaCheckoutAdd01 ({ commit }, payload) {
    commit('QTDA_CHECKOUTADD01', payload)
  },
  QtdaCheckoutSub01 ({ commit }, payload) {
    commit('QTDA_CHECKOUTSUB01', payload)
  },
  DeleteCheckout01 ({ commit }, payload) {
    commit('DELETE_CHECKOUT01', payload)
  },
  SetItem01: ({ commit }, payload) => new Promise((resolve) => {
    commit('ITEM_SELECTED01', payload)
    resolve()
  }),
  SetModal01: ({ commit }, payload) => new Promise((resolve) => {
    commit('SET_MODAL01', payload)
    resolve()
  }),
  SearchProd01 ({ commit }, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: SearchProduto,
        variables: {
          payload: payload
        }
      })
      .then(res => {
        commit('SEARCH_PROD01', res.data.data.SearchNameProd)
        resolve()
      })
    })
  },
  PushProd ({ commit, dispatch }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      let newItem = {
        code: payload.code,
        tipo: payload.tipo,
        name: payload.name,
        status: true,
        preco: typeof payload.preco === 'string' ? parseFloat(payload.preco.split('.').reduce((c, n) => c + n).replace(',', '.').replace('R$ ', '')) : payload.preco,
        oferta: typeof payload.oferta === 'string' ? parseFloat(payload.oferta.split('.').reduce((c, n) => c + n).replace(',', '.').replace('R$ ', '')) : payload.oferta,
        img: payload.img,
        descricao: payload.descricao,
        dateOfertaStart: payload.dateOfertaStart,
        dateOfertaEnd: payload.dateOfertaEnd,
        categoria: payload.categoria,
        gerEstoque: payload.gerEstoque,
        statusEstoque: payload.statusEstoque,
        estoque: parseInt(payload.estoque),
        exibeSemEstoque: payload.exibeSemEstoque,
        pendencia: payload.pendencia,
        visibilidade: payload.visibilidade,
        visualizacao: payload.visualizacao,
        atributos: payload.atributos,
        estoqueVariavel: [],
        caracter: payload.caracter,
        destaque: payload.destaque,
        dateCreate: new Date()
      }
      console.log(newItem)
      this.$http.post('', {
        query: `
          mutation($payload: iproduto) {
            _CreateProduct(payload: $payload) {
              status,
              message,
              produto {
                id,
                code,
                tipo,
                name,
                status,
                preco,
                oferta,
                img {
                  id,
                  img
                },
                descricao,
                dateOfertaStart,
                dateOfertaEnd,
                categoria,
                gerEstoque,
                statusEstoque,
                estoque,
                pendencia,
                visibilidade,
                visualizacao,
                dateCreate,
                destaque,
                caracter {
                  id,
                  name,
                  icon
                },
                atributos {
                  active,
                  id,
                  name,
                  values {
                    active,
                    id,
                    name,
                    selected
                  }
                },
                estoqueVariavel {
                  id,
                  src {
                    quantidade,
                    values {
                      id,
                      idParent,
                      name,
                      value
                    }
                  }
                }                
              }
            }
          }
        `,
        variables: {
          payload: newItem
        }
      })
      .then(res => {
        console.log(res)
        dispatch('ClearProdEdit')
        dispatch('PushMsg', { msg: res.data.data._CreateProduct.message, color: res.data.data._CreateProduct.status ? 'green' : 'red' })
        dispatch('Loading', false)
        commit('PUSH_PROD', res.data.data._CreateProduct.produto)
        resolve(res.data.data._CreateProduct.produto)
        router.push('/painel/produtos')
      })
    })
  },
  FilterCateg: ({ commit }, payload) => new Promise((resolve) => {
    commit('FILTER_CATEG', payload)
    resolve()
  }),
  SelectPropProd: ({ commit }, payload) => new Promise((resolve) => {
    commit('SELECT_PROPPROD', payload)
    resolve()
  }),
  GetSuggestion (_, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: suggestionproduto,
        variables: {
          payload: payload
        }
      })
      .then(res => {
        resolve(res.data.data.GetSuggestion)
      })
    })
  },
  changeFilterProdStore ({ commit }, payload) {
    return new Promise((resolve) => {
      commit('CHANGE_FILTER_PROD_STORE', payload)
      resolve()
    })
  },
  GetFilterPrice () {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: `
          query {
            GetFilterPrice
          }
        `
      })
      .then(res => {
        resolve(res.data.data.GetFilterPrice)
      })
    })
  },
  GetProducFilterPrice ({ commit }, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: filterprice,
        variables: {
          payload: payload
        }
      })
      .then(res => {
        commit('SET_PRODUTOS_STORE', { produtos: res.data.data.GetProducFilterPrice, init: 1 })
        resolve(res.data.data.GetProducFilterPrice)
      })
    })
  },
  GetProductView ({ commit }, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: getproduct,
        variables: {
          id: payload
        }
      })
      .then(res => {
        commit('ITEM_SELECTED01', res.data.data.GetProduct)
        resolve(res.data.data.GetProduct)
      })
    })
  },
  _UpdateProductVisualization (_, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: `
          mutation ($id: Int) {
            _UpdateProductVisualization (id: $id)
          }
        `,
        variables: {
          id: payload
        }
      })
      .then(() => {
        resolve()
      })
    })
  }
}
